$(function () {

    /**
     * FORM CONDITIONAL FIELDS
     */

    $('input[type="radio"]').on('change', (e) => {
        if (e.target.checked) {
            $('[data-visible="' + e.target.id + '"]').removeClass('d-none');
            $('[data-invisible="' + e.target.id + '"]').addClass('d-none');
        }
    });

    $('input[type="radio"]:checked').trigger('change');

    /**
     * FIN - FORM CONDITIONAL FIELDS
     */

});

